import React from 'react'
import ProjectDetail from "../../components/Project/Detail/ProjectDetail";
export default function ProjectDetails() {
  return (
    <div style={{paddingBottom:'3rem'}}>
        <ProjectDetail/>
    </div>
  )
}
